/**
 * Concat logo image data and type into digestible image src uri
 * @param {string} data.logoImg - Base64 encoded image data (ex. iVBORw0KGgo==)
 * @param {string} data.logoImgType - Image type of uploaded image (ex. image/jpg)
 */
export const attachBase64ImageExtension = ({ logoImg, logoImgType }) => {
  return `data:${logoImgType};base64,${logoImg}`;
};
